import { DataType } from 'components/table/types';

export type tableColumns = Record<string, DataType>;
export const tableColumns: tableColumns = {
	createdAt: 'date',
	startDate: 'date',
	expirationDate: 'date',
	name: 'string',
	type: 'custom',
	percentage: 'string',
	isActive: 'custom',
};
